import {getToken} from "../utils/userUtility";
import {guid} from "../utils/commonUtility";


class RealtimeStore {
    musicoWssSocket = null;
    channels = {};

    connectionPromise = null;

    partsMap = {};

    numFailed = 0;
    connectionIssue = false;

    connected() {
        // console.log(this.musicoWssSocket ? this.musicoWssSocket.readyState : 'null')
        return this.musicoWssSocket && this.musicoWssSocket.readyState === 1;
    }

    constructor() {
    }

    internalConnect() {
        this.connectionIssue = false;
        return new Promise(async (resolve, reject) => {
            let token = getToken();
            if (!token) {
                console.log('token not valid');
                resolve();
                this.connectionIssue = true;
                return;
            }
            try {
                this.disconnect();
                this.musicoWssSocket = new WebSocket(`${process.env.REACT_APP_REALTIME_BACKEND}?Authorization=${token}`);
                this.musicoWssSocket.onerror = (err) => {
                    console.log('error: ', err)
                    this.connectionIssue = true;
                    resolve();
                };
                this.musicoWssSocket.onopen = () => {
                    // console.log('connection opened')
                    Object.keys(this.channels).forEach(channelId => {
                        this.musicoWssSocket.send(JSON.stringify({action: 'subscribe', channel: channelId}));
                    });
                    this.connectionIssue = false;
                    resolve();
                };
                this.musicoWssSocket.onmessage = (event) => {
                    // console.log(event);
                    const data = JSON.parse(event.data);
                    const payload = this.processEventData(data);
                    if (payload && data.channel && this.channels[data.channel]) {
                        // console.log('parsed payload: ', payload);
                        this.channels[data.channel](data.channel, payload);
                    }
                };

            } catch (err) {
                console.log('error connecting to websocket: ', err);
                resolve();
                this.connectionIssue = true;
            }
        });

    }

    processEventData(data) {
        let part = data.part;
        if (!part) {
            part = '1/1';
        }
        let partSplit = part.split('/');
        let i = parseInt(partSplit[0], 10);
        let total = parseInt(partSplit[1], 10);

        // console.log('received part: ', i, ' out of:', total);
        let payload = null;
        if (total === 1) {
            payload = typeof data.message === 'string' ? JSON.parse(data.message) : data.message;
        } else {
            let guid = data.guid;
            let currentData = this.partsMap[guid];
            if (!currentData) {
                currentData = {
                    total: total,
                    numReceived: 1,
                    payloads: []
                };
                currentData.payloads[i] = data.message;
                this.partsMap[guid] = currentData;
            } else {
                currentData.payloads[i] = data.message;
                currentData.numReceived++;
                if (currentData.numReceived === total) {
                    payload = '';
                    for (let j = 1; j <= currentData.total; j++) {
                        payload += currentData.payloads[j];
                    }
                    delete this.partsMap[guid];
                    payload = JSON.parse(payload);
                }
            }
        }
        return payload;
    }

    setReconnectHandler = (reconnectHandler) => {
        this.reconnectHandler = reconnectHandler;
    }

    async connect() {
        // console.log('connect called');
        if (this.connected()) {
            // console.log('connected!');
            this.connectionPromise = null;
            return;
        }
        if (!this.connectionPromise || this.connectionIssue) {
            // console.log('no connection promise', this.connecting);
            // if (!getToken()) {
            //     console.log('no token found')
            //     return;
            // }
            this.connectionPromise = this.internalConnect();
            clearInterval(this.interval);
            this.interval = setInterval(() => {
                if (!this.connected()) {
                    this.numFailed++;
                    this.internalConnect();
                    console.log('num failed: ' + this.numFailed)
                } else {
                    if (this.numFailed > 0 && this.reconnectHandler) {
                        this.reconnectHandler();
                    }
                    this.numFailed = 0;
                }
            }, 60 * 1000); // make sure we are connected every 5 minutes
        }
        return this.connectionPromise;
    };

    disconnect() {
        // console.log('disconnect called!!')
        if (this.musicoWssSocket) {
            this.musicoWssSocket.close();
            this.connectionPromise = null;
        }
    };

    async subscribe(channelId, onSubscribe) {
        await this.connect();
        if (this.connected()) {
            this.musicoWssSocket.send(JSON.stringify({action: 'subscribe', channel: channelId}));
            this.channels[channelId] = onSubscribe;
        } else {
            console.log('not connected - failed to subscribe to channel', channelId);
        }
    };

    async unsubscribe(channelId) {
        await this.connect();
        if (this.connected()) {
            this.musicoWssSocket.send(JSON.stringify({action: 'unsubscribe', channel: channelId}));
            this.channels[channelId] = null;
        } else {
            console.log('not connected - failed to unsubscribe from channel', channelId);
        }
    };

    async send(channel, data) {
        // console.log(channel, data);
        try {
            if (this.connected()) {
                let payload = JSON.stringify(data);
                let maxLength = 100000;
                // console.log('payload length: ', payload.length);
                let numParts = Math.ceil(payload.length / maxLength);
                // console.log('splitting: numParts: ', numParts);
                let id = guid();
                for (let i = 0; i < numParts; i++) {
                    const part = JSON.stringify(payload.substring(i * maxLength, (i + 1) * maxLength));
                    this.musicoWssSocket.send(`{"action": "send", "channel": "${channel}", "guid": "${id}", "part": "${i + 1}/${numParts}","data": ${part}}`);
                }
            } else {
                this.connect();
                console.log('not connected - failed to send message to channel', channel);
            }
        } catch (err) {
            console.log('error sending: ', err);
        }
    }
}

const realtimeStore = new RealtimeStore();
export default realtimeStore;
